import * as React from 'react';
import { WuiModal, WuiPersistentModal, WuiSlideOut, WuiToast } from '../components';
import { WuiThemeContext } from '../theming/theme-provider';
import { OverlaysApiContext } from './overlay-provider';
export function WuiOverlayRenderer({ theme: themeFromProps }) {
    const ctx = React.useContext(OverlaysApiContext);
    if (!ctx) {
        throw new Error('<WuiOverlayProvider /> not initialized!');
    }
    const themeCtx = React.useContext(WuiThemeContext);
    const themeFromContext = themeCtx?.theme;
    const { modals, persistentModals, slideOuts, toasts } = ctx.state;
    const children = (React.createElement(React.Fragment, null,
        Object.entries(modals).map(([uid, { api, props, component }]) => {
            if (props) {
                props.theme = props.theme ?? themeFromProps ?? themeFromContext;
            }
            return React.createElement(WuiModal, {
                key: uid,
                uid,
                api,
                ...props,
            }, React.createElement(component, { api }));
        }),
        Object.entries(persistentModals).map(([uid, { api, props, component }]) => {
            return React.createElement(WuiPersistentModal, {
                key: uid,
                uid,
                api,
                ...props,
            }, React.createElement(component, { api }));
        }),
        Object.entries(slideOuts).map(([uid, { api, props, component }]) => {
            if (props) {
                props.theme = props.theme ?? themeFromProps ?? themeFromContext;
            }
            const c = React.createElement(component, { api });
            return React.createElement(WuiSlideOut, {
                key: uid,
                uid,
                api,
                ...props,
            }, c);
        }),
        Object.entries(toasts)
            .reverse()
            .map(([uid, { api, props }]) => {
            return React.createElement(WuiToast, {
                key: uid,
                api,
                uid,
                ...props,
            });
        })));
    return React.createElement('wui-overlay-server', {}, children);
}
